"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminRevokeUserFromCommunityPoolRequestBodyToJSON = exports.AdminRevokeUserFromCommunityPoolRequestBodyFromJSONTyped = exports.AdminRevokeUserFromCommunityPoolRequestBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function AdminRevokeUserFromCommunityPoolRequestBodyFromJSON(json) {
    return AdminRevokeUserFromCommunityPoolRequestBodyFromJSONTyped(json, false);
}
exports.AdminRevokeUserFromCommunityPoolRequestBodyFromJSON = AdminRevokeUserFromCommunityPoolRequestBodyFromJSON;
function AdminRevokeUserFromCommunityPoolRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
        'reason': json['reason'],
        'adminNotes': !(0, runtime_1.exists)(json, 'adminNotes') ? undefined : json['adminNotes'],
    };
}
exports.AdminRevokeUserFromCommunityPoolRequestBodyFromJSONTyped = AdminRevokeUserFromCommunityPoolRequestBodyFromJSONTyped;
function AdminRevokeUserFromCommunityPoolRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'reason': value.reason,
        'adminNotes': value.adminNotes,
    };
}
exports.AdminRevokeUserFromCommunityPoolRequestBodyToJSON = AdminRevokeUserFromCommunityPoolRequestBodyToJSON;
